import { Box, Button, CircularProgress } from "@mui/material";
import { BUTTON_PRIMARY } from "../assets/constants/Constants";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from 'i18next';
import {LS_LOCAL_LANGUAGE } from "../assets/constants/BrowserStorageKeys";

const ButtonComponent = ({title,handleClick, startIcon, type = BUTTON_PRIMARY, disabled = false, variant = 'contained', customClass = "", buttonId = "",endIcon = null}) => {
  const [isLoading, setIsLoading] = useState(false);
  const localLanguage = localStorage.getItem(LS_LOCAL_LANGUAGE);
  const { t } = useTranslation();
  const onClickHandler = async () => {
    setIsLoading(true);
    const handleClickPromise = handleClick(); // Start handleClick execution
    const timeoutPromise = new Promise(resolve => setTimeout(resolve, 2000)); // Create a 2-second delay
    await Promise.all([handleClickPromise, timeoutPromise]); // Wait for both to complete
    setIsLoading(false);
  };
	const translateLocal = (ln, key) => {
		if(localLanguage){
			const fixedT = i18n.getFixedT(ln);
				return fixedT(key);
    }
	};
  const renderTranslatedBox = () => {
    const primaryText = t(title);
    const secondaryText = translateLocal(localLanguage, title);
    if (secondaryText && primaryText !== secondaryText) {
      return (
        <box>
          <span style={{ display: "block" }}>{primaryText}</span>
          <span style={{ display: "block" }}>{secondaryText}</span>
        </box>
      );
    }
    return (
      <box>
        <span style={{ display: "block" }}>{primaryText}</span>
      </box>
    );
  };

  
  return(
    <Box component="section" className={variant === 'contained' ? `button-container ${customClass}` : `button-container` }>
      <Button 
        className={`button ${customClass} ${type} ${disabled || isLoading ? "disabled-button" : ""}`} 
        id={buttonId}
        size="large" 
        variant={variant} 
        onClick={onClickHandler} 
        startIcon={isLoading ? <CircularProgress size={24} /> : startIcon}
        endIcon={endIcon}
        disabled={disabled || isLoading}
        >
        {!isLoading && renderTranslatedBox()}
      </Button>
    </Box>

  ) 
};
export default ButtonComponent;
